// client/src/components/login/LoginForm.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; //Keep useNavigate
import { useTranslation } from 'react-i18next';
// import { useAuth } from '../../context/AuthContext';
import { login } from '../../api/authApi'; // Import API function
import './LoginForm.css';
// import axios from 'axios';

function LoginForm() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const { login } = useAuth();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [loginError, setLoginError] = useState('');
    const [loading, setLoading] = useState(false);
    const [activationLink, setActivationLink] = useState(null);

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
        setUsernameError('');   // Clear username error when typing in username
        setLoginError(''); // Clear login error when typing in username
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError('');   // Clear password error when typing in password
        setLoginError(''); // Clear login error when typing in password
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoginError('');
        setLoading(true);
        setActivationLink(null);

        let hasError = false;

        if (!username) {
            setUsernameError(t('login.errors.usernameRequired'));
            hasError = true;
        }

        if (!password) {
            setPasswordError(t('login.errors.passwordRequired'));
            hasError = true;
        }

        if (hasError) {
            setLoading(false);
            return;
        }
        
        const credentials = {
            username: username,
            password: password,
        };

        try {
            // Call the login function from authApi.js
            const response = await login(credentials);

            // --- Success Handling ---
            if (response) {// Check if API call was successful (adjust based on actual response/error handling)
                // TODO: Call context login if using AuthContext
                // contextLogin(response.userData, response.token);
                console.log("Login successful, navigating to dashboard:", response);
                navigate('/dashboard');
            }
        } catch (error) {
            console.error("Login failed:", error);

            // Check if the error has the userId attached by handleApiError
            // And if the error message matches the specific 'accountNotActive' translation
            // Or check error.code if we added that in handleApiError: if (error.code === 'ACCOUNT_NOT_ACTIVE' && error.userId)
            if (error.userId && error.message === t('login.errors.accountNotActive')) {
                console.log(`Account not active for userId: ${error.userId}. Redirecting to activation.`);
                // Redirect directly to the activation page
                navigate(`/activate/${error.userId}`);
                // No need to set loginError if redirecting immediately
            } else {
                 // For other errors, just display the message from handleApiError
                 setLoginError(t('login.errors.loginFailed')); // Fallback just in case
                //  setLoginError(error.message || t('errors.login.loginFailed')); // Fallback just in case
            }
        } finally {
            setLoading(false);
        }
    };

 return (
        <div className="login-form">
            <h2 className="login-form__title">{t('login.loginTitle')}</h2>
            <form onSubmit={handleSubmit}>
                {loginError && (
                    <div className="login-form__error">
                        {loginError}
                        {activationLink && (
                            <Link to={activationLink} className="login-form__link">
                                {t('login.activateHere')}
                            </Link>
                        )}
                    </div>
                )}
                <div className="login-form__group">
                    <label htmlFor="username" className="login-form__label">{t('login.usernameLabel')}</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={username}
                        onChange={handleUsernameChange}
                        placeholder={t('login.usernamePlaceholder')}
                        className={`login-form__input ${usernameError ? 'login-form__input--error' : ''}`}
                    />
                    {usernameError && <div className="login-form__error">{usernameError}</div>}
                </div>
                <div className="login-form__group">
                    <label htmlFor="password" className="login-form__label">{t('login.passwordLabel')}</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={handlePasswordChange}
                        placeholder={t('login.passwordPlaceholder')}
                        className={`login-form__input ${passwordError ? 'login-form__input--error' : ''}`}
                    />
                    {passwordError && <div className="login-form__error">{passwordError}</div>}
                </div>
                <button type="submit" className="login-form__button" disabled={loading}>
                    {loading ? t('login.loggingIn') : t('login.login')}
                </button>
            </form>

            <div className="login-form__links">
                <Link to="/forgot-password" className="login-form__link">{t('login.forgotPassword')}</Link>
                <Link to="/register" className="login-form__link">{t('login.createAccount')}</Link>
            </div>
        </div>
    );
}

export default LoginForm;